import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { KwkPageBase } from '@zero/self-service/feature-kwk/base';
import { CustomerPromotionComponent } from './components/customer-promotion/customer-promotion.component';

@Component({
  selector: 'self-service-kwk-page',
  templateUrl: './kwk-page.component.html',
  imports: [CustomerPromotionComponent, AsyncPipe, TranslocoPipe],
})
export class KwkPageComponent extends KwkPageBase {}
